export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#FFD5E3\"/><path d=\"M9.634 17.084v4.523a1 1 0 00.498.865l5.374 3.12a1 1 0 001.004 0l5.374-3.12a1 1 0 00.498-.865v-4.523m-6.373 8.27V17.27m9.395-1.94l-6.312 3.624a.2.2 0 01-.2 0l-2.583-1.48a.2.2 0 010-.347l6.284-3.624a.2.2 0 01.199-.001l2.611 1.48a.2.2 0 01.001.348zm-18.764 0l6.284 3.624a.2.2 0 00.2 0l2.583-1.48a.2.2 0 000-.347l-6.283-3.624a.2.2 0 00-.2 0l-2.583 1.48a.2.2 0 000 .346zm0-3.8l6.284-3.623a.2.2 0 01.2 0l2.583 1.48a.2.2 0 010 .346l-6.283 3.624a.2.2 0 01-.2 0l-2.583-1.48a.2.2 0 010-.346zm18.765 0l-6.312-3.624a.2.2 0 00-.2 0l-2.583 1.48a.2.2 0 000 .347l6.284 3.624a.2.2 0 00.199.001l2.611-1.48a.2.2 0 00.001-.348z\" stroke=\"#1D1D1B\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};